import { Box } from '@mui/material';
import React from 'react';
import { IntlShape } from 'react-intl';
import classNames from 'classnames';
import styles from './cost-amount-menu-section.module.scss'
import CostActionMenu from '../action-menu';

interface Props {
    intl: IntlShape;
    amount: number;
    variant?: 'total' | 'item';
    onAddNewCostClick?: () => void;
    onEditCostClick?: () => void;
    onDeleteCostClick?: () => void;
}

const CostAmountMenuSection: React.FC<Props> = (props) => {
    const { amount, intl, variant = 'total', onAddNewCostClick, onEditCostClick, onDeleteCostClick } = props;
    const formattedAmount = intl.formatNumber(amount, { maximumFractionDigits: 2, useGrouping: false });

    return(<Box className={styles.container}>
        <Box className={styles.menu}>
            <div className={classNames(styles.amount, { [styles.amountItem]: variant === 'item' })}>{formattedAmount}</div>
            {(onAddNewCostClick || onEditCostClick || onDeleteCostClick) && (
                <div className={styles.actionSlot}>
                    <CostActionMenu intl={intl} onAddNewCostClick={onAddNewCostClick} onEditCostClick={onEditCostClick} onDeleteCostClick={onDeleteCostClick} />
                </div>
            )}
        </Box>
    </Box>)
}

export default CostAmountMenuSection;
